import * as React from "react"
import {Box} from "@mui/material";
import {useComputed} from "@preact/signals-react";
import {ImageSeeker} from "@ui-seeker/core";

import {imageModalData} from "@signals";
import {matcherSKUDrawerData} from "../../@signals";
import {useProxiedImage} from "../../../@hooks";


export default function MatchersSKUsDrawerImage() {
	const imageURL = useComputed(() => matcherSKUDrawerData.value.thumbnail)
	const { decodedURL, imageResourceURL } = useProxiedImage(imageURL.value)

	return <Box display="flex" justifyContent="center" width={1}>
		<ImageSeeker
			src={imageResourceURL}
			sx={{
				height: 240,
				width: 240,
				objectFit: 'contain',
				objectPosition: 'center'
			}}
			onClick={() => imageModalData.value = {
				src: encodeURIComponent(decodedURL)
			}}
		/>
	</Box>
}
